import { addHours, addMinutes, getHours, getMinutes } from 'date-fns';
export var HOURS_IN_DAY = 24;
export var HOURS_TO_NOON = HOURS_IN_DAY / 2;
export var MINUTES_IN_HOUR = 60;
export function addHoursToTime(time, hoursToAdd) {
  var hours = time[0],
      minutes = time[1];
  return [modulo(hours + hoursToAdd, HOURS_IN_DAY), minutes];
}
export function addMinutesToTime(time, minutesToAdd) {
  var hours = time[0],
      minutes = time[1];
  var nextMinutes = minutes + minutesToAdd;
  var remainderMinutes = modulo(nextMinutes, MINUTES_IN_HOUR);

  if (remainderMinutes >= 0) {
    var nextHours = hours + Math.floor(nextMinutes / MINUTES_IN_HOUR);
    hours = modulo(nextHours, HOURS_IN_DAY);
    minutes = remainderMinutes;
  } else {
    minutes = nextMinutes;
  }

  return [hours, minutes];
}
export function addTimeToDate(date, time) {
  var hours = time[0],
      minutes = time[1];
  return addHours(addMinutes(date, minutes), hours);
}
export function getMeridiem(time) {
  var hours = time[0];
  return hours <= 11 ? 'AM' : 'PM';
}
export function getTimeFromDate(date) {
  return [getHours(date), getMinutes(date)];
}
export function modulo(n, m) {
  return (n % m + m) % m;
}